import { CsvFiles, getCsvFile } from 'lib/datoCms/queries/getCsvFile';
import { DatoCMSSiteSeo, DatoCmsHeader } from 'lib/datoCms/types';
import { DatoCmsSignUp, getAllSignUpLabels } from 'lib/datoCms/queries/getAllSignUpLabels';
import { Seo, SiteSeo } from 'components/seo';

import { DatoCmsConfig } from 'lib/types/dato-cms.response';
import { DatoSignUpErrorsLabels } from 'lib/types/signup-errors-label';
import { Layout } from 'components/Layout';
import PageContent from 'components/page-content/registrati/PageContent';
import { cleanConfig } from 'lib/datoCms/utils';
import { getDatoCMSData } from 'sites/snai/lib/datoCms/queries/getDatoCMSData';

interface PageProps {
  site: SiteSeo | DatoCMSSiteSeo;
  meta: DatoCmsConfig;
  signUp: DatoCmsSignUp;
  header: DatoCmsHeader;
  labels: Record<string, string>;
  signUpError: DatoSignUpErrorsLabels;
}

export const getStaticProps = async ({ locale }) => {
  console.log('getStaticProps : register');
  getCsvFile(CsvFiles.TownshipsFallback);

  const { signUp, signUpError } = await getAllSignUpLabels();
  try {
    const { site, header, allLabels: labels, config } = await getDatoCMSData('common', locale);

    const { seoMetaTags, canonical } = config ?? {};
    const meta = { seoMetaTags, canonical };

    return {
      props: {
        site,
        meta,
        header,
        labels,
        signUp,
        config: cleanConfig(config),
        signUpError,
      },
    };
  } catch (error) {
    return {
      notFound: true,
    };
  }
};

const Registrati = ({ site, header, signUp, signUpError, meta }: PageProps) => {
  const { seoMetaTags, canonical } = meta ?? {};
  return (
    <Layout fullWidth>
      <Seo siteSeo={site as SiteSeo} metaTags={seoMetaTags} canonicalUrl={canonical} />
      <PageContent header={header} signUpLabels={signUp} signUpLabelsError={signUpError} />
    </Layout>
  );
};

export default Registrati;
